// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1Xjud","footer":"ModalUpdate_footer__eyj-o"};